module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Calisto MT"
    }
  }, [_vm._v("Jacob's Wish")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "font-family": "Calisto Mt",
      "margin-left": "-10px",
      "margin-top": "20px",
      "font-weight": "normal !important"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_000#toc_id_1"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_001#toc_id_2"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_002#toc_id_3"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_004#toc_id_4"
    }
  }, [_vm._v("Chapter 1: Jacob’s Mysterious Briefcase")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_005#toc_id_5"
    }
  }, [_vm._v("Chapter 2: Fresh Wounds")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_006#toc_id_6"
    }
  }, [_vm._v("Chapter 3: Into Thin Air")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_007#toc_id_7"
    }
  }, [_vm._v("Chapter 4: A Mysterious Young Man")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_008#toc_id_8"
    }
  }, [_vm._v("Chapter 5: A Thornwood on Thornwood")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_010#toc_id_9"
    }
  }, [_vm._v("Chapter 6: A Midnight Dialogue")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_011#toc_id_10"
    }
  }, [_vm._v("Chapter 7: Sneaky Uncle Eustace – Part 1")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_012#toc_id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Sneaky Uncle Eustace – Part 2")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_013#toc_id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Ethylrift’s Unusual Gift")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_014#toc_id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: The Orphanage")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_015#toc_id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Conversations with The Fallen")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_016#toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Mr Thornwood’s Secret")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_018#toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Prune Juice, Porridge and Bog Rolls")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_019#toc_id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Say Hello to Hamlet and Emily… and a Moggy?")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_020#toc_id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Next Stop, Hailsham!")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_021#toc_id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: A Not-So-Great Encounter")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_022#toc_id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: The Rules Have Changed")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_023#toc_id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Kevin Vs. The Transient")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_024#toc_id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: There’s Always a First")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_025#toc_id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Hugo the great Vs. Emily Densmore")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_026#toc_id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21:  Onward and Upward")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_027#toc_id_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Medway and Thames")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_028#toc_id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Ethylrift: Friend or Foe")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_030#toc_id_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Lucid Dreaming and the Hallway of Practical Support and Arena Training")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_031#toc_id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Ladies First!")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_033#toc_id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Argus vs. Kobaloi")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_034#toc_id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: An Empath in Our Midst")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_035#toc_id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: The Valentina Incident")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_036#toc_id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: A Look into The Other Side")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_037#toc_id_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30: The Heart of Imoogi")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_038#toc_id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: The Atwood Twins")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_039#toc_id_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Fulfilling a Promise")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_040#toc_id_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: A Mysterious Girl")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_041#toc_id_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: Fighting a God")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_042#toc_id_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35: The Pain of Separation")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_043#toc_id_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36: Reformatory of The Forgotten")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_044#toc_id_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 37: Friends in Low Places")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_045#toc_id_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 38: The 5th Column")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_046#toc_id_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 39: The Archive Updated")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_047#toc_id_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 40: The End: The Beginning")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0